module.exports = __webpack_public_path__ + "img/smart-bus.9e524e7d.jpg";